import React, { useState, useEffect } from 'react';
import Chip from '@mui/material/Chip';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import Avatar from '@mui/material/Avatar';
import { Col, Row } from 'reactstrap';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axios from 'constants/axios';
import { Field, Form } from 'react-final-form'
import moment from 'moment';
import { connect } from 'react-redux';
import { getProductDetails, getVisitedCategory, bulkRequest, addToCart, getCartDetails, togglePopup } from 'actions/buyer';
import { NotificationManager } from 'react-notifications';
import AxiosRequest from 'sagas/axiosRequest'
import { FormGroup, Label, Input } from 'reactstrap';
import helpertFn from 'constants/helperFunction';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { required, number, number0, maxLength4 } from 'constants/validations';
import { Helmet } from "react-helmet";
import ReactStrapTextField from 'components/ReactStrapTextField';
import { CircularProgress } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import AppConfig from 'constants/config'
import GuestRegisterDialog from 'components/GuestRegisterDialog';
import { campaignsVisible } from 'util/campaignVisibility';
import { liquidSurchargeRate, liquidSurchargeForLine } from 'util/liquidSurcharge';

// The product coupon/gift is shown as one of the media rows in the detail section (next to Discount,
// Chemical Combination etc). It reuses the coupon/gift icon SHAPES from the product card's OfferPanel
// but recoloured to the same dark blue (#072791) as every other zmdi icon in this section, so it
// reads as native to the section rather than as the coloured card pill.
const OFFER_BLUE = '#072791';
// `size` lets the same mark sit inline on the product title line (small) as well as in a media row
// (the 34px default the rows were built around).
const CouponIcon = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={OFFER_BLUE} aria-hidden="true" style={{ flexShrink: 0 }}>
    <path d="M20 6H4c-1.1 0-2 .9-2 2v3a2 2 0 0 1 0 4v3c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-3a2 2 0 0 1 0-4V8c0-1.1-.9-2-2-2zm-6 11h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z" />
  </svg>
);
const GiftIcon = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={OFFER_BLUE} aria-hidden="true" style={{ flexShrink: 0 }}>
    <path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z" />
  </svg>
);

const ProductDetail = (props) => {
  const navigate = useNavigate()
  const params = useParams()
  const [invalid, setInvalid] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [bulkQuantity, setBulkQuantity] = useState(0);
  const [error, setError] = useState(false);
  const [amount, setAmount] = useState(0);
  const [discount, setDiscount] = useState('');
  const [updatedCount, setUpdatedCount] = useState(0);
  const [bulkReqEptr, setBulkReqEptr] = useState(0);
  const [bestOffer, setBestOffer] = useState('');
  const [minBulk, setMinBulk] = useState(10000);
  const [showRegisterDialog, setShowRegisterDialog] = useState(false);
  // Whether the seller's picture of the product gift is open over the page.
  const [giftImageOpen, setGiftImageOpen] = useState(false);

  const buyerToken = localStorage.getItem('buyer_token');
  const tempToken = localStorage.getItem('temp_token');
  const shouldBlur = !buyerToken && !tempToken;

  const handleClick = () => {
    navigate('/view-seller')
  }

  useEffect(() => {
    props.getProductDetails({ inventory_id: params.id })
  }, [])

  const handleOpenModal = async () => {
    let { productData } = props;
    let data1 = { Id: productData && productData[0] && productData[0].Product._id }
    let response1 = await AxiosRequest.axiosBuyerHelperFunc('post', 'product/bestOffer', '', data1)
    let offer = response1 && response1.data && response1.data.data.slice(0, 1);
    let ePtr = productData && productData.length > 0 && productData[0].ePTR;
    const configResult = await axios({
      method: 'post',
      url: `${AppConfig.baseUrl}systemConfig/getAllSystemConfigList`,
      headers: {
        'Content-Type': 'application/json',
        token: localStorage.getItem('buyer_token')
      }
    })
    if (configResult.data && configResult.data.detail && !configResult.data.error) {
      configResult.data.detail.map((data) => {
        if (data.key === "minBulk") {
          setMinBulk(data.value)
        }
      })
    }
    setOpenModal(true)
    setDiscount('')
    setBulkReqEptr(offer.length > 0 ? Number((offer[0].price).toFixed(2)) : ePtr)
    setBestOffer(offer[0])
  }

  const handleClose = () => {
    setOpenModal(!openModal)
    setBulkQuantity('')
    setDiscount('')
    setBulkReqEptr(0)
    setAmount(0)
  }

  const handleBulkRequest = async () => {
    try {
      let { productData } = props;
      let data = {
        product_name: productData && productData.length > 0 && productData[0].Product.name,
        quantity: Number(bulkQuantity),
        discount: discount ? discount : 0,
        amount: Number(amount),
        ptr: Number(bulkReqEptr),
        Id: productData && productData.length > 0 && productData[0].Product._id
      }
      const result = await axios.post('/bulkRequest/createBulkRequest', data, {
        headers: {
          'Content-Type': 'application/json',
          'token': localStorage.getItem('buyer_token')
        }
      })
      if (result.data.error) {
        NotificationManager.error(result.data.title)
      } else {
        NotificationManager.success(result.data.title);
      }
      handleClose();
    } catch (error) {
      NotificationManager.error('Something went wrong, Please try again')
    }
  }

  const handleIncremented = (key, event) => {
    if ((Number(updatedCount) + Number(props.productData[0].min_order_quantity)) <= Number(props.productData[0].max_order_quantity)) {
      setUpdatedCount(Number(updatedCount) + Number(props.productData[0].min_order_quantity))
    }
  }

  const handleDecremented = (key, event) => {
    if (updatedCount !== props.productData[0].min_order_quantity && updatedCount - props.productData[0].min_order_quantity >= props.productData[0].min_order_quantity) {
      setUpdatedCount(Number(updatedCount) - Number(props.productData[0].min_order_quantity))
    }
  }

  const handleChanged = (e, key) => {
    if (key === 'discount') {
      setDiscount(e.target.value)
    } else {
      setBulkQuantity(e.target.value)
    }
    let { productData } = props;
    let minOrder = productData && productData.length > 0 && productData[0].Product.minOrder;
    if (key === 'bulkQuantity') {
      let value = Number(e.target.value) * Number(bulkReqEptr) - ((Number(e.target.value) * Number(bulkReqEptr)) * Number(discount) / 100);
      if (value < minOrder) {
        setError(true)
        setAmount(value)
      } else {
        setError(false)
        setAmount(value)
      }
    }
    if (key === 'discount') {
      let value = Number(bulkQuantity) * Number(bulkReqEptr) - ((Number(bulkQuantity) * Number(bulkReqEptr)) * Number(e.target.value) / 100);
      if (value < minOrder) {
        setError(true)
        setAmount(value)
      } else {
        setError(false)
        setAmount(value)
      }
    }
  }

  const handleQuantityChanged = () => {
    NotificationManager.warning('Please use buttons for increment and decrement')
  };

  const onSubmit = async (e) => {
    setDisabled(true)
    let data
    if (props.productData[0].Discount) {
      if (updatedCount >= props.productData[0].min_order_quantity && updatedCount <= props.productData[0].max_order_quantity && Number.isInteger(updatedCount) === true) {
        data = {
          cart_details: [{
            inventory_id: props.productData[0].inventory_id,
            quantity: updatedCount
          }]
        }
        let response = await AxiosRequest.axiosBuyerHelperFunc('post', 'cart/addtoCart', '', data)
        if (response.data.error) {
          NotificationManager.error(response.data.title)
        } else {
          NotificationManager.success(response.data.title)
          const isLogin = localStorage.getItem("buyer_token");
          if (isLogin) {
            props.getCartDetails({})
          }
        }
      }
    } else if (quantity >= props.productData[0].min_order_quantity && quantity <= props.productData[0].max_order_quantity && Number.isInteger(quantity) === true) {
      data = {
        cart_details: [{
          inventory_id: props.productData[0].inventory_id,
          quantity: updatedCount
        }]
      }
      let response = await AxiosRequest.axiosBuyerHelperFunc('post', 'cart/addtoCart', '', data)
      if (response.data.error) {
        NotificationManager.error(response.data.title)
      } else {
        NotificationManager.success(response.data.title)
        const isLogin = localStorage.getItem("buyer_token");
        if (isLogin) {
          props.getCartDetails({})
        }
      }
    } else {
      NotificationManager.error(!quantity ? 'Please enter quantity' : "Please check Minimum & Maximum order quantity.")
    }
  }

  const maxLengthCheck = (event) => {
    if (event.target.value > props.productData[0].max_order_quantity) {
      event.target.value = props.productData[0].min_order_quantity
      setInvalid(true)
    }
  }

  useEffect(() => {
    if (props.productData && props.productData[0]) {
      setQuantity(props.productData[0].min_order_quantity)
      setUpdatedCount(props.productData[0]?.min_order_quantity)
      setInvalid(false)
    }
  }, [props.productData])

  // Safe toFixed helper — prevents crash when value is undefined/null
  const safeToFixed = (val, digits = 2) => {
    const num = Number(val);
    return isNaN(num) ? '-' : num.toFixed(digits);
  }

  const user = localStorage.getItem("buyer_token")
  const { productData, users, activeCoupon } = props;
  // Only the product-tier coupon/gift is shown here (seller/platform tiers are not surfaced on this
  // page). activeCoupon is always product-tier, but guard defensively. Withheld from guests, in
  // step with the cards, which show them no campaign either (see util/campaignVisibility).
  const productOffer = campaignsVisible() && activeCoupon && (!activeCoupon.tier || activeCoupon.tier === 'product') ? activeCoupon : null;
  const productOfferIsGift = productOffer && productOffer.type === 'gift';
  // Same hover tooltip as the product-card OfferPanel. A gift gets the fuller tip built below -
  // on the title line the label is only "Free Gift", so the detail has to be on hover.
  const productOfferTip = productOfferIsGift ? 'gift is given on item purchase' : 'coupon is given per lot';
  const productGiftImage = productOffer && productOffer.gift ? productOffer.gift.image : '';

  // The seller's picture of the gift, shown over the page rather than in a new tab: the buyer is
  // mid-decision on this product and should not be navigated away from it to see what they get.
  const openGiftImage = () => {
    if (!productGiftImage) return;
    setGiftImageOpen(true);
  };

  /*
  Everything the buyer needs to judge the gift, on hover: what it is, what it is worth and whose
  brand it is. It cannot live on the line itself - "Free Gift" has to stay short enough to sit
  beside the product name - and the picture is the rest of the answer, so the tip says it is one
  click away rather than leaving the click undiscoverable.

  Written to sell the gift rather than to file it: a kicker line that says the thing is free, the
  gift's own name as the headline, and its value as a badge - the one number that decides whether a
  buyer cares. Amber against the tooltip's dark ground, the same colour the gift pills use on the
  cards, so a gift reads as a gift wherever it turns up.
  */
  const GIFT_AMBER = '#ffcf70';
  const productGiftTip = (() => {
    const gift = (productOffer && productOffer.gift) || {};
    return (
      <div style={{ padding: '2px 2px 3px', maxWidth: 230 }}>
        <div style={{
          fontSize: 10.5,
          fontWeight: 700,
          letterSpacing: 1.1,
          textTransform: 'uppercase',
          color: GIFT_AMBER
        }}>
          Yours free with this item
        </div>
        <div style={{ fontSize: 14.5, fontWeight: 700, lineHeight: 1.35, marginTop: 3 }}>
          {gift.description || 'Free gift'}
        </div>
        {gift.brand ?
          <div style={{ fontSize: 12, opacity: 0.85, marginTop: 1 }}>by {gift.brand}</div> : null}
        {Number(gift.price) > 0 ?
          <div style={{
            display: 'inline-block',
            marginTop: 6,
            padding: '2px 9px',
            borderRadius: 999,
            background: GIFT_AMBER,
            color: '#3b2600',
            fontSize: 12,
            fontWeight: 700
          }}>
            Worth ₹{gift.price}
          </div> : null}
        {productGiftImage ?
          <div style={{
            marginTop: 8,
            paddingTop: 6,
            borderTop: '1px solid rgba(255, 255, 255, 0.25)',
            fontSize: 12,
            fontWeight: 600
          }}>
            Click to view the image →
          </div> : null}
      </div>
    );
  })();

  /*
  The product-level campaign, shown on the product NAME line rather than as one of the media rows
  below it: this is an offer on the product being looked at, so it reads with the title.
    coupon - the media row's icon and description, unchanged ("Flat ₹120 OFF")
    gift   - reads "Free Gift"; what it is, what it is worth and its brand are on hover, and
             clicking it opens the picture the seller uploaded in a popup over this page
  */
  const inlineProductOffer = () => {
    if (!productOffer) return null;
    const clickable = productOfferIsGift && !!productGiftImage;
    return (
      <Tooltip
        title={productOfferIsGift ? productGiftTip : productOfferTip}
        arrow
        // The gift tip is a small card, not a one-line hint, so it gets room to breathe. The plain
        // coupon tip keeps the default cramped tooltip it shares with the rest of the page.
        componentsProps={productOfferIsGift
          ? { tooltip: { sx: { p: '10px 12px', maxWidth: 260 } } }
          : undefined}
      >
        <span
          onClick={clickable ? openGiftImage : undefined}
          role={clickable ? 'button' : undefined}
          tabIndex={clickable ? 0 : undefined}
          onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') openGiftImage(); } : undefined}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            color: OFFER_BLUE,
            fontWeight: 600,
            // Sits beside an <h1>, so the media rows' own 14px reads as fine print here. 18px is the
            // theme's $font-size-lg (what h3 uses), which keeps it in the section's type scale
            // while still being legible next to the product name.
            fontSize: 18,
            whiteSpace: 'nowrap',
            // The pointer and the tooltip already say it is clickable; an underline on the title
            // line reads as a link to another page, which this is not.
            cursor: clickable ? 'pointer' : 'default',
            ...(shouldBlur ? { filter: 'blur(4px)', userSelect: 'none', pointerEvents: 'none' } : {})
          }}
        >
          {productOfferIsGift ? <GiftIcon size={26} /> : <CouponIcon size={26} />}
          {productOfferIsGift
            ? 'Free Gift'
            : (productOffer.coupon_value ? `Flat ₹${productOffer.coupon_value} OFF` : 'Coupon on this item')}
        </span>
      </Tooltip>
    );
  };
  let title = params.keyword && params.keyword.toUpperCase().split('-').join(' ');
  const bgColor = (productData && productData.length > 0 && productData[0].medi_type === 'Ethical branded') || (productData && productData.length > 0 && productData[0].medi_type === 'Others') ? '#ff7000' :
    productData && productData.length > 0 && productData[0].medi_type === 'Cool chain' ? '#0b68a8' :
      (productData && productData.length > 0 && productData[0].medi_type === 'Surgical') || (productData && productData.length > 0 && productData[0].medi_type === 'OTC') || (productData && productData.length > 0 && productData[0].medi_type === 'Generic') ? '#038d0e' : '#072791'

  const composeValidators = (...validators) => value =>
    validators.reduce((error, validator) => error || validator(value), undefined)

  const getError = () => !bulkQuantity ? "This field is required" : bulkQuantity && isNaN(Number(bulkQuantity)) ? 'Must be a number' : Number(bulkQuantity) <= -1 ? 'Value cannot be negative' : Number(bulkQuantity) === 0 ? "Can't be zero" : bulkQuantity && bulkQuantity.length > 4 ? `Must be ${4} characters or less` : ""

  const DummyPriceSection = () => (
    <div style={{ position: 'relative' }}>
      {/* Blurred dummy content */}
      <div style={{ filter: 'blur(5px)', userSelect: 'none', pointerEvents: 'none' }}>
        <div>
          <Chip
            size='small'
            style={{ padding: '17px 10px' }}
            label="BUY XX GET X FREE"
          />
          <div className='mt-2'>
            <span className='priceColorProduct'>&#x20B9; xxx.xx</span>
            <span className='originalPriceProduct ml-2'>&#x20B9; xxx.xx</span>
            <br />
            <span className='text-danger'>*Excluding GST</span>
          </div>
        </div>
      </div>
      {/* Login overlay on top of blur */}
      <div
        style={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer'
        }}
        onClick={props.togglePopup}
      >
      </div>
    </div>
  );

  return (
    <React.Fragment>
      {props.loading ?
        <div className="loader-view"
          style={{ height: props.width >= 1200 ? 'calc(100vh - 259px)' : 'calc(100vh - 238px)' }}>
          <CircularProgress />
        </div>
        :
        <div className='pt-3'>
          <Helmet>
            <title>Buy {title} Online In India - Medimny</title>
            <meta name="title" content={`Buy ${title} Online In India - Medimny`} />
            <meta name="description" content={`Medimny is a B2B E-Commerce platform for Pharmaceutical Products for Distributors, Stockists and Retail Drug Stores serving entire nation. Buy ${title} Online In India.`} />
          </Helmet>
          {
            productData.map((value, key) => {
              return (
                <React.Fragment key={key}>
                  <Chip
                    label={value.medi_type === 'Others' ? 'PCD' : value.medi_type}
                    size='small'
                    style={{ backgroundColor: `${bgColor}`, color: 'white', marginBottom: '10px' }}
                  />
                  {
                    value && value.medi_attribute.includes('Jumbo Deal') ?
                      <Chip
                        label='Jumbo Deal'
                        size='small'
                        style={{ backgroundColor: `${bgColor}`, color: 'white', marginBottom: '10px', marginLeft: '10px' }}
                      />
                      : ""
                  }
                  {/* The product-level coupon/gift rides on the title line. `key === 0` because the
                      offer belongs to the listing being viewed, not to each row of this map. */}
                  <div className="d-flex align-items-center flex-wrap mb-2" style={{ gap: 14 }}>
                    <h1 className="mb-0"><strong>{value.Product.name}</strong></h1>
                    {key === 0 ? inlineProductOffer() : null}
                  </div>
                </React.Fragment>
              )
            })
          }
          {
            productData.map((value, key) => {
              return (
                <React.Fragment key={key}>
                  <NavLink className="buyerRedirectNavlink" to={`/view-seller/${value && value.Seller && value.Seller._id}`}>
                    <Chip
                      label={value.Seller.company_name}
                      deleteIcon={
                        <Avatar className="bg-success iconAvtarColor text-white">
                          <ThumbUpIcon style={{ fontSize: '0.6rem' }} /></Avatar>
                      }
                      onClick={handleClick}
                      size='small'
                    />
                  </NavLink>
                </React.Fragment>
              )
            })
          }
          <Row className="mb-4">
            {productData.map((value, key) => (
              <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-5">
                <NavLink className="buyerRedirectNavlink" to={`/view-company/${value.Company._id}`}>
                  <div className="media flex-nowrap mb-2">
                    <div className="mr-3"><i className={`zmdi zmdi-city-alt jr-fs-xlxl text-primary`} /></div>
                    <div className="media-body">
                      <h5 className="mb-1 text-grey">Manufacturer</h5>
                      <p className="mb-0 text-primary">{value.Company.name}</p>
                    </div>
                  </div>
                </NavLink>
              </Col>
            ))}

            {productData.map((value, key) => (
              <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-5">
                <div className="media flex-nowrap mb-2">
                  {(value.expiry_status === 'Short Expiry') ?
                    <React.Fragment>
                      <div className="mr-3"><i className={`zmdi zmdi-calendar-close animated infinite wobble jr-fs-xlxl text-danger`} /></div>
                      <div className="media-body">
                        <h5 className="mb-1 text-danger">Expiry Date</h5>
                        <p className="mb-0 text-danger">{moment(value.expiry_date).format('ll')}</p>
                      </div>
                    </React.Fragment>
                    :
                    <React.Fragment>
                      <div className="mr-3"><i className={`zmdi zmdi-calendar-close jr-fs-xlxl text-primary`} /></div>
                      <div className="media-body">
                        <h5 className="mb-1 text-grey">Expiry Date</h5>
                        <p className="mb-0">{moment(value.expiry_date).format('ll')}</p>
                      </div>
                    </React.Fragment>
                  }
                </div>
              </Col>
            ))}

            {productData.map((value, key) => (
              <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-4">
                <div className="media flex-nowrap mb-2">
                  <div className="mr-3"><i className={`zmdi zmdi-collection-text jr-fs-xlxl text-primary`} /></div>
                  <div className="media-body">
                    <h5 className="mb-1 text-grey">Type</h5>
                    <p className="mb-0">{value.Product.product_type}</p>
                  </div>
                </div>
              </Col>
            ))}

            {productData.map((value, key) => (
              <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-4">
                <div className="media flex-nowrap mb-2">
                  <div className="mr-3"><i className={`zmdi zmdi-long-arrow-down jr-fs-xlxl text-primary`} /></div>
                  <div className="media-body">
                    <h5 className="mb-1 text-grey">Minimum Order Quantity</h5>
                    <p className="mb-0">{value.min_order_quantity}</p>
                  </div>
                </div>
              </Col>
            ))}

            {productData.map((value, key) => (
              <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-4">
                <div className="media flex-nowrap mb-2">
                  <div className="mr-3"><i className={`zmdi zmdi-long-arrow-up jr-fs-xlxl text-primary`} /></div>
                  <div className="media-body">
                    <h5 className="mb-1 text-grey">Maximum Order Quantity</h5>
                    <p className="mb-0">{value.max_order_quantity}</p>
                  </div>
                </div>
              </Col>
            ))}

            {productData.map((value, key) => (
              <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-4">
                <div className="media flex-nowrap mb-2">
                  <div className="mr-3"><i className={`zmdi zmdi-folder jr-fs-xlxl text-primary`} /></div>
                  <div className="media-body">
                    <h5 className="mb-1 text-grey">Product Category</h5>
                    <p className="mb-0">{value.Product_Category.name}</p>
                  </div>
                </div>
              </Col>
            ))}

            {productData.map((value, key) => (
              <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-4">
                <div className="media flex-nowrap mb-2">
                  <div className="mr-3"><h1 style={{ fontSize: '37px', color: '#072791' }}>₹</h1></div>
                  <div className="media-body">
                    <h5 className="mb-1 text-grey">MRP</h5>
                    <p className="mb-0">₹{safeToFixed(value.MRP)}</p>
                  </div>
                </div>
              </Col>
            ))}

            {productData.map((value, key) => (
              <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-4">
                <div className="media flex-nowrap mb-2">
                  <div className="mr-3"><i className={`zmdi zmdi-shopping-basket jr-fs-xlxl text-primary`} /></div>
                  <div className="media-body">
                    <h5 className="mb-1 text-grey">GST</h5>
                    <p className="mb-0">{value.Product.GST}%</p>
                  </div>
                </div>
              </Col>
            ))}

            {productData.map((value, key) => (
              <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-4">
                <div className="media flex-nowrap mb-2">
                  <div className="mr-3"><i className={`zmdi zmdi-pin jr-fs-xlxl text-primary`} /></div>
                  <div className="media-body">
                    <h5 className="mb-1 text-grey">Country Of Origin</h5>
                    <p className="mb-0">{value.Product.country_of_origin}</p>
                  </div>
                </div>
              </Col>
            ))}

            {productData.map((value, key) => (
              <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-4">
                <div className="media flex-nowrap mb-2">
                  <div className="mr-3"><i className={`zmdi zmdi-library jr-fs-xlxl text-primary`} /></div>
                  <div className="media-body">
                    <h5 className="mb-1 text-grey">Chemical Combination</h5>
                    <p className="mb-0">{value.Product.chem_combination}</p>
                  </div>
                </div>
              </Col>
            ))}

            {productData.map((value, key) => {
              return (
                value.Discount && value.Discount !== undefined ?
                shouldBlur ?
                    <>
                      <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-4">
                        <div style={{ position: 'relative' }}>
                          <div  className="media flex-nowrap mb-2" style={{ filter: 'blur(4px)', userSelect: 'none', pointerEvents: 'none' }}>
                            <React.Fragment>
                            <div className="mr-3">
                              <i className={`zmdi zmdi-label jr-fs-xlxl text-primary`} />
                            </div>
                          </React.Fragment>
                          <div className="media-body">
                            <React.Fragment>
                              <h5 className="mb-1 text-grey">Offer</h5>
                              <span className={'DiscountPrice'}>Buy {"xx"} Get {"x"} Free </span>
                            </React.Fragment>
                             </div>
                          </div>
                        </div>
                      </Col>
                      </>:
                  <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-4">
                    <div style={{ position: 'relative' }}>
                      <div
                        className="media flex-nowrap mb-2"
                        style={shouldBlur ? { filter: 'blur(4px)', userSelect: 'none', pointerEvents: 'none' } : {}}
                      >
                        {value.Discount === undefined ?
                          <React.Fragment style={{ display: 'none' }}></React.Fragment>
                          :
                          <React.Fragment>
                            <div className="mr-3">
                              <i className={`zmdi zmdi-label jr-fs-xlxl text-primary`} />
                            </div>
                          </React.Fragment>
                        }
                        <div className="media-body">
                          {value.Discount && value.Discount.discount_type === "Discount" ?
                            <React.Fragment>
                              <h5 className="mb-1 text-grey">Discount on PTR</h5>
                              <p className="mb-0">{safeToFixed(value.Discount && value.Discount.discount_per)}%</p>
                            </React.Fragment>
                            :
                            <React.Fragment>
                              {value.Discount && value.Discount.discount_type === "Same" ?
                                <React.Fragment>
                                  <h5 className="mb-1 text-grey">Offer</h5>
                                  <span className={'DiscountPrice'}>Buy {value.Discount.discount_on_product.purchase} Get {value.Discount.discount_on_product.bonus} Free</span>
                                </React.Fragment>
                                :
                                value.Discount && value.Discount.discount_type === "SameAndDiscount" ?
                                  <React.Fragment>
                                    <h5 className="mb-1 text-grey">Offer</h5>
                                    <span className={'DiscountPrice'}>Buy {value.Discount.discount_on_product.purchase} Get {value.Discount.discount_on_product.bonus} Free, and {safeToFixed(value.Discount && value.Discount.discount_per)}% Off</span>
                                  </React.Fragment>
                                  :
                                  value.Discount && value.Discount.discount_type === "DifferentAndDiscount" ?
                                    <React.Fragment>
                                      <h5 className="mb-1 text-grey">Offer</h5>
                                      <span className={'DiscountPrice'}>Buy {value.Discount.discount_on_product.purchase} Get {value.Discount.discount_on_product.bonus} {value.OtherProducts?.name} Free, and {safeToFixed(value.Discount && value.Discount.discount_per)}% Off</span>
                                    </React.Fragment>
                                    :
                                    value.Discount && value.Discount.discount_type === "Different" ?
                                      <React.Fragment>
                                        <h5 className="mb-1 text-grey">Offer</h5>
                                        <span className={'DiscountPrice'}>Buy {value.Discount.discount_on_product.purchase} Get {value.Discount.discount_on_product.bonus} {value.OtherProducts?.name} Free</span>
                                      </React.Fragment>
                                      :
                                      <React.Fragment style={{ display: 'none' }}></React.Fragment>
                              }
                            </React.Fragment>
                          }
                        </div>
                      </div>
                    </div>
                  </Col>
                  :
                  <React.Fragment key={key}></React.Fragment>
              )
            })}

            {/* The product coupon/gift used to be a media row here. It now sits on the product name
                line above, where an offer on this very product reads with its title. */}

            {productData.map((value, key) => (
              (value.expiry_status === 'Short Expiry') && value.batchNumber ?
                <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-4">
                  <div className="media flex-nowrap mb-2">
                    <div className="mr-3"><i className={`zmdi zmdi-format-list-numbered jr-fs-xlxl text-primary`} /></div>
                    <div className="media-body">
                      <h5 className="mb-1 text-grey">Batch number</h5>
                      <p className="mb-0">{value.batchNumber}</p>
                    </div>
                  </div>
                </Col> : ""
            ))}

            {/* LAST in the row, deliberately: it is the only line here that adds to what the buyer
                pays, so it reads after everything describing the product itself.

                The charge for ONE unit of this listing - the product's own rate applied to its ePTR,
                the same ex-GST base the cart and the API charge it on, so this is exactly what one
                unit adds at checkout.

                Only rendered when there is something to say: products carrying no rate (most of
                them) show nothing, and a viewer who cannot see prices never receives the rate at
                all, since /v1/productDetails sends it only alongside ePTR. */}
            {productData.map((value, key) => {
              const perUnitDeliveryCharge = liquidSurchargeForLine(
                liquidSurchargeRate(value.Product),
                Number(value.ePTR)
              );
              return perUnitDeliveryCharge > 0 ? (
                <Col key={key} xs={6} sm={6} md={6} lg={4} xl={4} className="pt-4">
                  <div className="media flex-nowrap mb-2">
                    <div className="mr-3"><i className={`zmdi zmdi-truck jr-fs-xlxl text-primary`} /></div>
                    <div className="media-body">
                      <h5 className="mb-1 text-grey">Liquid Delivery Charge</h5>
                      {/* Only the amount is bold - the sentence around it stays the weight of every
                          other value in this section. */}
                      <p className="mb-0">
                        This product has delivery charge of{' '}
                        <strong>&#x20B9;{perUnitDeliveryCharge.toFixed(2)}</strong> per unit.
                      </p>
                    </div>
                  </div>
                </Col>
              ) : (
                <React.Fragment key={key}></React.Fragment>
              );
            })}
          </Row>

          {productData.map((value, key) => {
            return (
              <div key={key}>
                {shouldBlur ? (
                  <DummyPriceSection />
                ) : (
                  <div>
                    {value.Discount && value.Discount.discount_type === "Discount" ?
                      <div>
                        <span className='priceColorProduct'>&#x20B9;{safeToFixed(value.ePTR)}</span>
                        <span className='originalPriceProduct ml-2'>&#x20B9;{safeToFixed(value.PTR)}</span>
                        <br />
                        <span className='text-danger'>*Excluding GST</span>
                      </div>
                      :
                      value.Discount && value.Discount.discount_type === "Same" ?
                        <div>
                          <h5 className="mb-1 text-grey">Offered Price :</h5>&nbsp;
                          <span className={'priceColor'}>&#x20B9;{safeToFixed(value.ePTR)}</span>&nbsp;
                          <span className={'originalPrice font'}>&#x20B9;{safeToFixed(value.PTR)}</span>
                          <br />
                          <span className='text-danger'>*Excluding GST</span>
                        </div>
                        :
                        value.Discount && value.Discount.discount_type === "SameAndDiscount" ?
                          <div>
                            <h5 className="mb-1 text-grey">Offered Price :</h5>&nbsp;
                            <span className={'priceColor'}>&#x20B9;{safeToFixed(value.ePTR)}</span>&nbsp;
                            <span className={'originalPrice font'}>&#x20B9;{safeToFixed(value.PTR)}</span>
                            <br />
                            <span className='text-danger'>*Excluding GST</span>
                          </div>
                          :
                          value.Discount && value.Discount.discount_type === "DifferentAndDiscount" ?
                            <div>
                              <h5 className="mb-1 text-grey">Offered Price :</h5>&nbsp;
                              <span className={'priceColor'}>&#x20B9;{safeToFixed(value.ePTR)}</span>&nbsp;
                              <span className={'originalPrice font'}>&#x20B9;{safeToFixed(value.PTR)}</span>
                              <br />
                              <span className='text-danger'>*Excluding GST</span>
                            </div>
                            :
                            <span className='priceColorProduct'>&#x20B9;{safeToFixed(value.ePTR)}</span>
                    }
                    {value.Discount && value.Discount.discount_type === "Different" ?
                      <div><span className='text-danger'>*Excluding GST</span></div> : ''
                    }
                    {value.Discount === undefined ?
                      <div><span className='text-danger'>*Excluding GST</span></div> : ''
                    }
                    {helpertFn.showPrepaid(value.medi_type, value.Product.isPrepaid && value.Product.isPrepaid, value.prepaidInven && value.prepaidInven) &&
                      <div>
                        <Chip label={'Only Prepaid'} size='small' style={{ backgroundColor: 'red', color: 'white' }} />
                      </div>
                    }
                    <br />
                    <div style={{ display: "flex", marginTop: "-7px" }}>
                      <span className="mt-1 text-grey" onClick={(e) => handleDecremented('minOrdntity', e)}>
                        <i className="zmdi zmdi-minus-circle-outline zmdi-hc-2x"></i>
                      </span>
                      <Input
                        id="minOrderQuantity"
                        name="minOrderQuantity"
                        type="number"
                        value={updatedCount}
                        placeholder="Quantity"
                        max={props.productData[0].max_order_quantity}
                        min={props.productData[0].min_order_quantity}
                        onChange={() => handleQuantityChanged()}
                        onInput={maxLengthCheck}
                        style={{ width: "100px", fontSize: "17px", marginLeft: "5px", marginRight: "1px", textAlign: 'center', backgroundColor: '#fff' }}
                      />
                      <span className="ml-1 mt-1 text-grey" onClick={(e) => handleIncremented('minOrderQuantity', e)}>
                        <i className="zmdi zmdi-plus-circle-o zmdi-hc-2x"></i>
                      </span>
                    </div>
                  </div>
                )}
              </div>
            )
          })}

          <Row style={{ visibility: invalid === true ? "" : "hidden" }}>
            <h5 className="mt-2 ml-3 text-danger">Quantity should be between Minimum & Maximum order quantity.</h5>
          </Row>

          {productData.map((value, key) => {
            if (value && value.Seller) {
              return <div key={key} className='ml-1'>
                {shouldBlur ?
                  <button
                    style={{ padding: '10px 15px', backgroundColor: '#072791', color: 'white', borderRadius: '5px', border: 'none', marginRight: "30px" }}
                    onClick={props.togglePopup}
                  >
                    Show deals
                  </button>
                  :
                  <button
                    disabled={disabled}
                    style={{ padding: '10px 15px', backgroundColor: '#072791', color: 'white', borderRadius: '5px', border: 'none', marginRight: "30px" }}
                    onClick={tempToken && !buyerToken ? () => setShowRegisterDialog(true) : onSubmit}
                  >
                    Add To Cart
                  </button>
                }
                {(user !== null && users && users.bulkRequest === true) ?
                  <button style={{ padding: '10px 15px', backgroundColor: '#072791', color: 'white', borderRadius: '5px', border: 'none' }} onClick={handleOpenModal}>Bulk Request</button>
                  : null
                }
              </div>
            } else {
              return <div key={key} className='row ml-1'>
                <button style={{ padding: '10px 15px', backgroundColor: '#072791', color: 'white', borderRadius: '5px', border: 'none', marginRight: "30px", cursor: 'default' }}>
                  Product Not Available
                </button>
              </div>
            }
          })}

          <Dialog open={openModal} onClose={handleClose} fullWidth={true}>
            <DialogTitle id="alert-dialog-title" className='pb-0'>Bulk Request</DialogTitle>
            <Form
              onSubmit={handleBulkRequest}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <DialogContent >
                    <div className=''>
                      {productData.map((value, key) => (
                        <div key={key} className='row justify-content-center'>
                          <FormGroup className={'col-sm-10 col-lg-10 col-md-10 col-xs-10 col-xl-10 mb-0'}>
                            <Label for="exampleEmail">Product Name</Label>
                            <span className='text-danger float-right'>(All prices excluding GST)</span>
                            <Input type="text" value={value.Product.name} readOnly style={{ backgroundColor: "#e1e1e1" }} />
                          </FormGroup>
                          <FormGroup className={'col-sm-10 col-lg-10 col-md-10 col-xs-10 col-xl-10 m-0 p-0 pl-3'}>
                            {bestOffer && <Label for="name" className='mt-3 text-primary'>{`${bestOffer.disc && bestOffer.disc.name === 'Same' ? 'Best Offer: Buy ' + bestOffer.disc.discount_on_product.purchase + ' and get ' + bestOffer.disc.discount_on_product.bonus + ' free' :
                              bestOffer.disc && bestOffer.disc.name === 'SameAndDiscount' ? 'Best Offer: Buy ' + bestOffer.disc.discount_on_product.purchase + ' and get ' + bestOffer.disc.discount_on_product.bonus + ' free and ' + safeToFixed(bestOffer.disc.discount_per) + '% discount' :
                                bestOffer.disc && bestOffer.disc.name === 'Discount' ?
                                  'Best Offer: ' + bestOffer.disc.discount_per + '% discount' :
                                  bestOffer.disc && bestOffer.disc.name === 'DifferentAndDiscount' ?
                                    'Best Offer: Buy ' + bestOffer.disc.discount_on_product.purchase + ' and get ' + bestOffer.disc.discount_on_product.bonus + ' ' + bestOffer.inven[0].productName + ' free and ' + safeToFixed(bestOffer.disc.discount_per) + '% discount' :
                                    bestOffer.disc && bestOffer.disc.name === 'Different' ?
                                      'Best Offer: Buy ' + bestOffer.disc.discount_on_product.purchase + ' and get ' + bestOffer.disc.discount_on_product.bonus + ' ' + bestOffer.inven[0].productName + ' free' : ''}`}</Label>}
                          </FormGroup>
                        </div>
                      ))}
                      {productData.map((value, key) => (
                        <div key={key} className='row justify-content-center'>
                          <FormGroup className={'col-sm-5 col-lg-5 col-md-5 col-xs-5 col-xl-5 pt-2'}>
                            <Label for="exampleEmail">Best Offered Effective PTR</Label>
                            <Input type="text" value={bulkReqEptr} readOnly style={{ backgroundColor: "#e1e1e1" }} />
                          </FormGroup>
                          <FormGroup className={'col-sm-5 col-lg-5 col-md-5 col-xs-5 col-xl-5 pt-2'}>
                            <Label for="exampleEmail">Estimated Effective PTR</Label>
                            <Input type="text" value={(isNaN(amount) || isNaN(bulkQuantity) || bulkQuantity === 0) ? 0 : (Number(amount) / Number(bulkQuantity)).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 })} readOnly style={{ backgroundColor: "#e1e1e1" }} />
                          </FormGroup>
                        </div>
                      ))}
                      <div className='row justify-content-center'>
                        <FormGroup className={'col-sm-10 col-lg-10 col-md-10 col-xs-10 col-xl-10'}>
                          <Label for="exampleEmail">Additional Expected Discount %</Label>
                          <Input type="select" name='discount' onChange={(e) => handleChanged(e, 'discount')}>
                            <option value=''>0%</option>
                            {productData && productData.length > 0 && productData[0].Product && productData[0].Product.discount.map((val, i) => <option key={i} value={val}>{val}%</option>)}
                          </Input>
                        </FormGroup>
                      </div>
                      <div className='row justify-content-center'>
                        <FormGroup className={'col-sm-5 col-lg-5 col-md-5 col-xs-5 col-xl-5'}>
                          <Label for="exampleEmail">Required Quantity</Label>
                          <Input type="text" name='bulkQuantity' id='bulkQuantity' value={bulkQuantity}
                            onChange={(e) => handleChanged(e, 'bulkQuantity')}
                            validate={composeValidators(number, maxLength4, number0, required)} />
                        </FormGroup>
                        <FormGroup className={'col-sm-5 col-lg-5 col-md-5 col-xs-5 col-xl-5'}>
                          <Label for="exampleEmail">Estimated value</Label>
                          <Input type="text" name='value' readOnly value={isNaN(amount) ? 0 : (Number(amount)).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 })} />
                          {error && <span className='text-danger'>Value can't be less than {minBulk && Number(minBulk).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</span>}
                        </FormGroup>
                      </div>
                    </div>
                  </DialogContent>
                  <DialogActions className="pr-4">
                    <div>
                      <Button onClick={handleClose} color='secondary'>Cancel</Button>
                      {(error === true || bulkQuantity === '' || getError()) ?
                        <Button disabled={true}>CREATE BULK REQUEST</Button> :
                        <Button type="submit" color='primary'>CREATE BULK REQUEST</Button>
                      }
                    </div>
                  </DialogActions>
                </form>
              )}
            />
          </Dialog>
        </div>
      }
      <GuestRegisterDialog open={showRegisterDialog} onClose={() => setShowRegisterDialog(false)} />

      {/* The seller's picture of the free gift, over the page. The buyer is mid-decision on this
          product, so seeing what the gift looks like must not cost them the page they are on. */}
      <Dialog open={giftImageOpen} onClose={() => setGiftImageOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle className="pb-1">
          {(productOffer && productOffer.gift && productOffer.gift.description) || 'Free gift'}
          {productOffer && productOffer.gift && productOffer.gift.brand ?
            <span className="text-muted" style={{ fontSize: 13, marginLeft: 8 }}>
              by {productOffer.gift.brand}
            </span> : null}
        </DialogTitle>
        <DialogContent>
          <img
            src={productGiftImage}
            alt={(productOffer && productOffer.gift && productOffer.gift.description) || 'Free gift'}
            style={{ display: 'block', margin: '0 auto', maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain', borderRadius: 4 }}
          />
          {productOffer && productOffer.gift && Number(productOffer.gift.price) > 0 ?
            <p className="text-center mb-0 mt-3" style={{ fontWeight: 600 }}>
              Worth ₹{productOffer.gift.price}, free with this item.
            </p> : null}
        </DialogContent>
        <DialogActions className="pr-4">
          <Button onClick={() => setGiftImageOpen(false)} color="secondary">Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

const mapStateToProps = ({ auth, buyer, seller }) => {
  const { data, otherSellers, relatedProducts, productData, visitedCategory, bulkRequest, addToCart, cartDetails, loading, activeCoupon } = buyer;
  const { user_details } = auth;
  const { userDetails } = seller;
  let users = userDetails ? userDetails : user_details
  return { data, otherSellers, relatedProducts, productData, visitedCategory, bulkRequest, addToCart, cartDetails, loading, user_details, users, activeCoupon }
};

export default connect(mapStateToProps, { getProductDetails, getVisitedCategory, bulkRequest, addToCart, getCartDetails, togglePopup })(ProductDetail)